"use strict";
exports.__esModule = true;
exports.getNextReplyId = exports.getNextCommentId = void 0;
var nextCommentId = 1;
var nextReplyId = 1;
function getNextCommentId() {
    return nextCommentId++;
}
exports.getNextCommentId = getNextCommentId;
function getNextReplyId() {
    return nextReplyId++;
}
exports.getNextReplyId = getNextReplyId;
